<div class="relative flex items-center justify-center w-full h-full">
  <div *ngFor="let image of images; let i = index" 
       [ngClass]="{'opacity-0': i !== currentIndex}" 
       class="absolute transition-opacity duration-1000 ease-in-out">
    <img [src]="image" alt="Carousel Image" loading="lazy" class="h-full w-full object-cover">
  </div>
</div>